const routes = [
  {
    path: "/login",
    component: () => import("@/views/Login.vue"),
    name: "login",
    meta: { noAuth: true },
  },
  {
    path: "/confirmation",
    component: () => import("@/views/Password/Confirmation.vue"),
    name: "confirmation",
    meta: { noAuth: true },
  },
];

export default routes;
